export default "__VITE_ASSET__CgkgRc69__"